export interface ErrorData {
  message: string;
  // Add other properties as needed
}

export class CustomError extends Error {
  status: number;
  data: ErrorData;

  constructor(message: string, status: number, data: ErrorData) {
    super(message);
    this.status = status;
    this.data = data;
  }
}
